import { Http } from "components/http/Http";

export default function useHttp() {
    const get = (url: string, payload: any = {}, headers = {}) => {
        return Http.make().get(url, payload, headers);
    };

    const post = (url: string, payload: any = {}, headers = {}) => {
        return Http.make().post(url, payload, headers);
    };

    const put = (url: string, payload: any = {}, headers = {}) => {
        return Http.make().put(url, payload, headers);
    };

    const destroy = (url: string, headers = {}) => {
        return Http.make().delete(url, headers);
    };

    return {
        get,
        post,
        put,
        delete: destroy,
        withCaptcha: (token: string) => Http.make().withCaptcha(token),
        instance: Http.make(),
    };
}